module.exports = __webpack_public_path__ + "static/img/200176.02a7977e.png";